/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_TitleInputs */

const en_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset Manager`)
};

const fr_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de préréglages`)
};

const de_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellungsmanager`)
};

const it_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestore preimpostato`)
};

const ru_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер предустановок`)
};

const es_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de ajustes preestablecidos`)
};

const zh_cn2_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设管理器`)
};

const ja_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットマネージャー`)
};

const hi_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट प्रबंधक`)
};

const pt_pt2_preset_manager_title = /** @type {(inputs: Preset_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciador de predefinições`)
};

/**
* | output |
* | --- |
* | "Preset Manager" |
*
* @param {Preset_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_title = /** @type {((inputs?: Preset_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_title(inputs)
	if (locale === "de") return de_preset_manager_title(inputs)
	if (locale === "it") return it_preset_manager_title(inputs)
	if (locale === "ru") return ru_preset_manager_title(inputs)
	if (locale === "es") return es_preset_manager_title(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_title(inputs)
	if (locale === "ja") return ja_preset_manager_title(inputs)
	if (locale === "hi") return hi_preset_manager_title(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_title(inputs)
	return en_preset_manager_title(inputs)
});